import React, { useEffect, useState } from 'react';
import './css/ResetPassword.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useParams } from 'react-router-dom';
import { faCircleXmark, faEye, faEyeSlash, faKey } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { toast } from 'react-toastify';
import { LoginPage } from './LoginPage';
import "./css/LoginPage.css";
import bugtrack from '../Assests/Frame 495.png'
import { Icon } from '@iconify/react';
import ResetIllustration from '../Assests/Reset Illustration.png'
import { url } from '../constants/url';

function ResetPassword() {
    const { resetToken } = useParams();

    const [isValid, setIsValid] = useState(true);
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    const navigate = useNavigate('')

    const [newPasswordError, setNewPasswordError] = useState('')
    const [confirmPasswordError, setConfirmPasswordError] = useState('')
    const [passwordUpdated, setPasswordUpdated] = useState(false)

    const [passwordVisible1, setPasswordVisible1] = useState(false);
    const [passwordVisible2, setPasswordVisible2] = useState(false);

    const togglePasswordVisibility1 = () => {
        setPasswordVisible1(!passwordVisible1);
    };
    const togglePasswordVisibility2 = () => {
        setPasswordVisible2(!passwordVisible2);
    };

    const forgotPasswordSuccess = () => {
        toast.success("Password reset successfully.", {
            position: "top-right",
            autoClose: 2500,
            pauseOnHover: false,
        })
    }

    const specialChars = /[!@#$%^&*(),.?":{}|<>]/;


    // Refer users.js file for backend code
    const verifyToken = async () => {
        try {
            const response = await fetch(`${url}/resetpassword/${resetToken}`);
            const data = await response.json();

            if (response.status === 200) {
                setIsValid(true);
            } else {
                setIsValid(false);
                console.log(data.message);
                setTimeout(() => {
                    navigate("/")
                }, 3000)
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        verifyToken();
    }, []);

    // Refer users.js file for backend code
    const handleResetPassword = async () => {
        verifyToken()
        if (newPassword === "") {
            setNewPasswordError("Please enter new password")
            return
        } else if (confirmPassword === "") {
            setConfirmPasswordError("Please confirm your password")
            return
        } else if (newPassword.length < 8) {
            setNewPasswordError('Password should be a minimum of 8 character');
            return;
        } else if (!specialChars.test(newPassword)) {
            setNewPasswordError('Password should include at least one special character');
            return;
        } else if (!/[A-Z]/.test(newPassword)) {
            setNewPasswordError('Password should include at least one capital alphabet');
            return;
        } if (newPassword !== confirmPassword) {
            setConfirmPassword('');
            setConfirmPasswordError('Password does not match!');
            return;
        } else {
            try {
                const response = await axios.post(`${url}/resetnewpassword/${resetToken}`, {
                    newPassword, confirmPassword
                })
                setNewPassword('')
                setConfirmPassword('')
                forgotPasswordSuccess()
                setPasswordUpdated(true)
                setTimeout(() => {
                    navigate("/")
                }, 1000)

            } catch (error) {
                console.log(error)
            }
        }
    };

    return (
        <div className="wrap_login_layout">
            <div className="layout-box">
                <div className="half white-half">
                    <div className="innerbox">
                        <div className="inner-box">
                            <img src={ResetIllustration} alt="Reset Illustration" className="inner-image" />
                            <p className="inner-text">Secure your account with a new password.</p>
                            <p className="inner-description">
                                Enter a strong, new password to regain access to your account.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="half gray-half">
                    <div className='icon_center'>
                        <img src={bugtrack} alt="Vulnytics" className="bugtrack-image" />
                    </div>
                    <div className="gray-inner-box">
                        <h2 className="form-heading">Reset your password</h2>
                        {isValid ? (
                            <>
                                <div className="input-group">
                                    <Icon icon="bi:key-fill" className="input-icon1" />
                                    <input
                                        type={passwordVisible1 ? 'text' : 'password'}
                                        placeholder="New Password"
                                        className="form-input password-input"
                                        value={newPassword}
                                        onChange={(e) => {
                                            setNewPassword(e.target.value);
                                            setNewPasswordError('');
                                        }}
                                    />
                                    <FontAwesomeIcon
                                        icon={passwordVisible1 ? faEye : faEyeSlash}
                                        onClick={togglePasswordVisibility1}
                                        className='eye_icon'
                                    />
                                    {newPasswordError && <p style={{ color: 'red', marginTop: '-5px' }}>{newPasswordError}</p>}
                                </div>

                                <div className="input-group">
                                    <Icon icon="bi:key-fill" className="input_passowrd_icon" />
                                    <input
                                        type={passwordVisible2 ? 'text' : 'password'}
                                        placeholder="Confirm Password"
                                        className="form-input password-input"
                                        value={confirmPassword}
                                        onChange={(e) => {
                                            setConfirmPassword(e.target.value);
                                            setConfirmPasswordError('');
                                        }}
                                    />
                                    <FontAwesomeIcon
                                        icon={passwordVisible2 ? faEye : faEyeSlash}
                                        onClick={togglePasswordVisibility2}
                                        className='eye_icon'
                                    />
                                    {confirmPasswordError && <p style={{ color: 'red', marginTop: '-5px' }}>{confirmPasswordError}</p>}
                                </div>

                                <button onClick={handleResetPassword} className="signin-button">Reset Password</button>
                            </>
                        ) : (
                            <div className='error_message'>
                                <p>Invalid token or token has expired.</p>
                            </div>
                        )}


                    </div>
                </div>
            </div>
            <div className='loginpage_copyright'>
                <p>© 2026, ISECURION Technology and Consulting Pvt. Ltd, All Rights Reserved.</p>
            </div>
        </div>
    )

}

export default ResetPassword;
